import React from 'react';
import { Menu, Row, Col } from 'antd';
import EChartsLogo from './EChartsLogo';

export default function NavBar(params) {

    return (
        <Row>
            <Col flex="auto"></Col>
            <Col flex="1560px"  >

                <div className="logo">
                    <EChartsLogo params="MQC" />
                </div>
                <Menu theme="dark" mode="horizontal" defaultSelectedKeys={params.actived} >
                    <Menu.Item  style={{ color: "white", fontSize: "14px" }} key="home" onClick={() => window.location.href="/"} >Home</Menu.Item>
                    <Menu.Item  style={{ color: "white", fontSize: "14px" }} key="results" onClick={() => window.location.href="/results"} >Results</Menu.Item>
                    <Menu.Item  style={{ color: "white", fontSize: "14px" }} key="tutorial" onClick={() => window.location.href="/tutorial"} >Tutorial</Menu.Item>
                    <Menu.Item  style={{ color: "white", fontSize: "14px" }} key="feedback" onClick={() => window.open("https://www.biodesign.ac.cn/feedback/MQC")} >Feedback</Menu.Item>
                </Menu>

            </Col>
            <Col flex="auto"></Col>
        </Row>
    )
}
